// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.example-tree-invisible {
  display: none;
}

.example-tree ul,
.example-tree li {
  margin-top: 0;
  margin-bottom: 0;
  list-style-type: none;
}

mat-tree {
  padding-left: 4%;
}

.filename-bar {
  min-height: 6.3%;
  background: #17A2B8;
  font-size: 14px;
  font-weight: bold;
  width: 100%;
  display: flex;
  padding: 1% 2% 0% 2%;
  box-sizing: border-box;
  align-items: center;
  color: white;
}

/* Highlighted button style */
.highlighted-btn {
  background-color: #116f7d !important;
  color: white !important;
}`, "",{"version":3,"sources":["webpack://./src/app/rule-config-component/template-tree/template-tree.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;;AAEA;;EAEE,aAAA;EACA,gBAAA;EACA,qBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,aAAA;EACA,oBAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;AACF;;AAEA,6BAAA;AACA;EACE,oCAAA;EACA,uBAAA;AACF","sourcesContent":[".example-tree-invisible {\r\n  display: none;\r\n}\r\n\r\n.example-tree ul,\r\n.example-tree li {\r\n  margin-top: 0;\r\n  margin-bottom: 0;\r\n  list-style-type: none;\r\n}\r\n\r\nmat-tree{\r\n  padding-left: 4%;\r\n}\r\n\r\n.filename-bar{\r\n  min-height: 6.3%;\r\n  background: #17A2B8;\r\n  font-size: 14px;\r\n  font-weight: bold;\r\n  width: 100%;\r\n  display: flex;\r\n  padding: 1% 2% 0% 2%;\r\n  box-sizing: border-box;\r\n  align-items: center;\r\n  color: white;\r\n}\r\n\r\n/* Highlighted button style */\r\n.highlighted-btn {\r\n  background-color: #116f7d !important;\r\n  color: white !important;\r\n}\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
